import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/SecondaryButton";
import { Snackbar, Alert, Backdrop, Button, CircularProgress, AlertColor, FormHelperText, Breadcrumbs } from "@mui/material";
import ListVehicles from "../../components/quoting/ListVehicles";
import EditVehicleForm from "../../components/EditVehicleForm";
import { QuoteService } from "../../services/quoteservice";
import { Flag, Limit, Policy, Vehicle } from "../../objects/policy";
import dayjs, { Dayjs } from "dayjs";
import { logActivityAsync } from "../../objects/events/loadEvents";
import JsonService from "../../services/jsonService";

function Vehicles() {
    var quoteService = new QuoteService();
    var navigate = useNavigate();

    const dispatch = useDispatch();
    const policyStore = useSelector((state: any) => state.policyReducer) as Policy;

    const [isPageLoad, setIsPageLoad] = useState(true);
    const [policy, setPolicy] = useState<Policy>(new Policy());
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isOpenAddContainer, setIsOpenAddContainer] = useState<boolean>(false);
    const [hasError, setHasError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [rateCycle, setRateCycle] = useState<string>("");

    const [isOpenSpinner, setIsOpenSpinner] = useState<boolean>(false);
    const rateCycleStore = useSelector((state: any) => state.rateCycleReducer) as string;

    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the vehicles screen",
                isException: false,
                error: "",
                level: "INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(() => {

        if (policyStore === undefined || policyStore == null) {
            navigate("/" + window.location.search);
        }

        setPolicy(policyStore);

        if (isPageLoad) {
            setRateCycle(rateCycleStore);
            window.scrollTo(0, 0);
            setIsPageLoad(false);
        }

        document.querySelector(".container-new-vehicle")?.classList.remove("expanded");
        document.querySelector(".row-add-vehicle")?.classList.add("rounded-br-lg");
        document.querySelector(".row-add-vehicle")?.classList.add("rounded-bl-lg");

        var labels = document.getElementsByClassName("btn-main-label");

        for (let item of labels) {
            item?.classList.toggle("hidden");
        }
    }, [policy]);

    function NavigateBack() {
        navigate("/details" + window.location.search);
    }

    function NavigateForward() {
        (async () => {
            try {

                if (policy.vehicles.length < 1) {
                    setErrorMessage("At least one vehicle is required");
                    setHasError(true);
                    return;
                }

                setIsOpenSpinner(true);

                var vehicles = [...policy.vehicles] as Vehicle[];

                vehicles = vehicles.map((v: Vehicle, i: number) => {
                    if (v.make?.toUpperCase() !== "FORD" && v.make?.toUpperCase() !== "LINCOLN") {
                        return v;
                    }

                    if (v.year < 2020) {
                        return v;
                    }

                    if (v.flags === undefined) {
                        v.flags = [];
                    }

                    return v
                });

                policy.vehicles = vehicles;

                var save = await quoteService.save(policy);

                if (!save.ok) {

                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Vehicles Screen - Save Quote",
                        message: `Quote# ${policy?.policyNumber ?? "N/A"} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: save?.error?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/vehicles");
                    navigate("/error?" + queryParams.toString());
                    setIsOpenSpinner(false);
                    return;
                }

                var savedQuote = save.data as Policy;
                savedQuote.integrationId = savedQuote.policyNumber;
                var policyNumber = savedQuote?.policyNumber ?? "";
                var defaults = await quoteService.setDefaultCoverages(policyNumber);

                if (!defaults.ok) {
                    var defaultError = JsonService.parseObject(await defaults.json());
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Vehicles Screen - Set Default Coverages On Vehicles",
                        message: `Quote# ${policy?.policyNumber ?? "N/A"} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: defaultError?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/vehicles");
                    navigate("/error?" + queryParams.toString());

                    setIsOpenSpinner(false);
                    return;
                }

                var serialize = await quoteService.serialize(policyNumber);

                if (!serialize.ok) {
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Vehicles Screen - Serialize Quote",
                        message: `Quote# ${policy?.policyNumber ?? "N/A"} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: serialize?.error?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/vehicles");
                    navigate("/error?" + queryParams.toString());
                    setIsOpenSpinner(false);
                    return;
                }

                var savedPolicy = serialize.data as Policy;
                savedPolicy.integrationId = savedPolicy.policyNumber;
                dispatch({ type: "UPDATE", payload: savedPolicy })
                navigate("/people" + window.location.search);
                setIsOpenSpinner(false);

            } catch (err) {
                var queryParams = new URLSearchParams(window.location.search);
                queryParams.set("returnUrl", "/vehicles");
                navigate("/error?" + queryParams.toString());
            }
        })();
    }

    function toggleAddVehicle(isShow: boolean) {
        if (isShow) {

            document.querySelector(".row-add-vehicle")?.classList.add("rounded-br-lg");
            document.querySelector(".row-add-vehicle")?.classList.add("rounded-bl-lg");
            var containerList = document.querySelector(".container-new-vehicle")?.classList;

            containerList?.add("expanded");

            setIsOpenAddContainer(true);
            //document.querySelector(".container-new-vehicle")?.classList.add("expanded");


            document.querySelector(".btn-main-label-add")?.classList.add("hidden");
            document.querySelector(".btn-main-label-close")?.classList.remove("hidden");



            setIsOpen(true);
        } else {
            document.querySelector(".row-add-vehicle")?.classList.remove("rounded-br-lg");
            document.querySelector(".row-add-vehicle")?.classList.remove("rounded-bl-lg");

            setIsOpenAddContainer(false);
            //document.querySelector(".container-new-vehicle")?.classList.remove("expanded");
            document.querySelector(".btn-main-label-add")?.classList.remove("hidden");
            document.querySelector(".btn-main-label-close")?.classList.add("hidden");

            setIsOpen(false);
        }
    }

    async function onSaveVehicleAction(vin: string,
        year: number,
        make: string,
        model: string,
        style: string,
        ownershipType: string,
        annualMiles: number) {

        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Add Vehcile",
                message: `Insured added vehicle with VIN ${vin}`,
                isException: false,
                error: "",
                level: "INFO",
                isSent: false
            });
        })();

        var vehicle = new Vehicle();

        vehicle.build(policy.vehicles.length,
            vin,
            year,
            make,
            model,
            "",
            ownershipType,
            annualMiles);

        var coverageDefaults = await quoteService.getDefaultCoverages(policy.policyNumber, "VEHICLE");

        if(coverageDefaults.ok){
            var defaultColl = coverageDefaults.data.defaultCoverages.find((m:any)=>m.coverage === "COLL");
            var defaultComp = coverageDefaults.data.defaultCoverages.find((m:any)=>m.coverage === "COMP");
            var defaultRent = coverageDefaults.data.defaultCoverages.find((m:any)=>m.coverage === "RENT");

            if(defaultColl !== null && defaultColl !== undefined ){
                var coll = new Limit();
                coll.limit = defaultColl.limit;
                coll.name = "COLL";
                coll.type = "VEHICLE";
                vehicle.coverageLimits.push(coll);
            }

            
            if(defaultComp !== null && defaultComp !== undefined ){
                var comp = new Limit();
                comp.limit = defaultComp.limit;
                comp.name = "COMP";
                comp.type = "VEHICLE";
                vehicle.coverageLimits.push(comp);
            }

            
            if(defaultRent !== null && defaultRent !== undefined ){
                var rent = new Limit();
                rent.limit = defaultRent.limit;
                rent.name = "RENT";
                rent.type = "VEHICLE";
                vehicle.coverageLimits.push(rent);
            }

            console.log({default_coverages: coverageDefaults.data.defaultCoverages });
        }

        policy.vehicles = [...policy.vehicles, vehicle];


        console.log({vehicles:policy.vehicles});
        toggleAddVehicle(false);

        setPolicy(policy);

        window.scrollTo(0, 0);
    }

    function onUpdateVehicleAction(carNumber: number,
        vin: string,
        year: number,
        make: string,
        model: string,
        style: string,
        ownershipType: string,
        annualMiles: number) {
        var cloneVehicles = [...policy.vehicles];
        var updateIndex = cloneVehicles.findIndex(m => m.carNumber === carNumber) ?? -1;

        if (updateIndex !== -1) {
            var updateCar = cloneVehicles[updateIndex];
            updateCar.carNumber = carNumber;
            updateCar.vin = vin;
            updateCar.year = year;
            updateCar.make = make;
            updateCar.model = model;
            updateCar.ownershipType = ownershipType;
            updateCar.annualMileage = annualMiles;

            var carToReplace = cloneVehicles.find(m => m.carNumber === carNumber) as Vehicle;
            Object.assign(carToReplace, updateCar);

            policy.vehicles = cloneVehicles;

            setPolicy(policy);

            (async () => {
                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "add_activity",
                    subject: "Updated Vehcile",
                    message: `Insured updated vehicle with VIN ${updateCar?.vin} (car# ${carNumber})`,
                    isException: false,
                    error: "",
                    level: "WARN",
                    isSent: false
                });
            })();

            return cloneVehicles;
        }
    }

    function removeVehicleAction(e: any, carNumber: number) {

        var clonedVehicles = [...policy.vehicles] as Vehicle[];

        var remainingVehciles = clonedVehicles.filter(m => {
            return m.carNumber !== parseInt(carNumber.toString())
        });
        var removedVehicle = clonedVehicles.find(m => m.carNumber == carNumber);

        var counter = 1;
        remainingVehciles.map((v, k) => {
            v.carNumber = counter;

            counter++;
        });
        
        policy.vehicles = remainingVehciles;

        setPolicy(policy);

        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Remove Vehcile",
                message: `Insured removed vehicle with VIN ${removedVehicle?.vin} (car# ${carNumber})`,
                isException: false,
                error: "",
                level: "WARN",
                isSent: false
            });
        })();

        return remainingVehciles;
    }

    return (
        <>
            <div className="container-add-vehicle w-100    ">
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[60vw] xl:w-[60vw] pt-10">
                    <h3 className="text-3xl font-light mt-8 mb-10 w-full">
                        <Breadcrumbs>
                            <h3 className="text-2xl pb-2 mt-0">Step 3 of 7</h3>
                        </Breadcrumbs>
                        Vehicles </h3>
                    <h4 className="text-2xl mb-7">We've identified the following vehicles at your address. Please remove any vehicles that you do not own and add additional vehicles if necessary.</h4>

                    <ListVehicles
                        key={policy.vehicles}
                        vehicles={policy.vehicles}
                        policyState={policy.ratedState}
                        removeVehicleAction={removeVehicleAction}
                        onClose={(e: any) => { toggleAddVehicle(false) }}
                        onSaveAction={onSaveVehicleAction}
                        onUpdateVehicleAction={onUpdateVehicleAction}
                    />

                    <hr className=" mb-10 mt-10" />

                    <div className="list-vehicles">

                        <div className="row-add-vehicle bg-[#e0e1dd] p-5 rounded-tl-lg rounded-tr-lg rounded-br-lg rounded-bl-lg" >
                            <span className="float-left font-bold text-lg text-ford-blue w-3/4 md:w-11/12 xl:w-11/12 2xl:w-11/12 ">Don't see your vehicle? Click Add.</span>
                            <span onClick={(e) => { toggleAddVehicle(true) }} className={"float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer btn-main-label-add "}>Add</span>
                            <span onClick={(e) => { toggleAddVehicle(false) }} className={"float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer btn-main-label-close hidden"}>Close</span>


                            <div className=" clear-both"></div>
                        </div>

                        <div className={`container-new-vehicle ${isOpenAddContainer ? "expanded" : ""}`}>

                            <EditVehicleForm
                                action="NEW"
                                parent="Vehicles"
                                policyState={policy.ratedState}
                                isVisible={isOpen}
                                onCloseAction={(e: any) => { toggleAddVehicle(false) }}
                                onSaveAction={onSaveVehicleAction}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-5  mt-28 p-5 bg-[#e0e1dd]">
                <div className="m-auto w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[60vw] xl:w-[60vw]">
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 ">Back</SecondaryButton>
                    <Button variant="contained" className="btn-continue hover:cursor-pointer w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  float-right bg-[#0071eb] text-[#ffffff] rounded-md active:bg-[#0a58ca]" onClick={NavigateForward}>Continue</Button>
                    <div className="clear-both">

                    </div>
                </div>
            </div>


            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenSpinner}
                onClick={() => { setIsOpenSpinner(false) }}>
                <CircularProgress color="inherit" />
            </Backdrop>


            <Snackbar
                open={hasError}
                autoHideDuration={6000}
                onClose={(e) => { setHasError(false) }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}>
                <Alert onClose={() => { setHasError(false) }} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default Vehicles;